import { Share } from "app/shares/interfaces";
import React, { useMemo } from "react";

import { DataProviderContext } from "app/main/DataProvider";
import { defaultMetaData } from "app/main/siteMetaData";
import { prepareNewsList } from "app/news/functions";
import { preparePerformance } from "app/main/functions";

/**
 * This function makes up for differences between the current API spec and what the frontend requires.
 * The function makes sure the frontend can work with older and newer versions of the API.
 */
function prepareShareObject(inShare: any): Share {
    preparePerformance(inShare.performance);

    if (inShare.analysis) {
        inShare.analysis.items = inShare.analysis.items.map((item: any) => {
            let id = item.id;
            if (item.url) {
                const parts = item.url.split("/");
                id = parts[parts.length - 1];
            }

            return {
                ...item,
                id
            };
        });
    }

    if (inShare.profitLossData) {
        inShare.profitAndLoss = inShare.profitLossData;
    }

    if (inShare.keyData) {
        if (typeof inShare.keyData.exchangeValue === "number") {
            inShare.keyData.exchangeValue = { value: inShare.keyData.exchangeValue, currency: "EUR" };
        }
    }

    inShare.news = prepareNewsList(inShare.news);

    return inShare;
}

/**
 * This hook returns metaData for the share detail page.
 */
export const useShareMetaData = (name: string, category: string, isin: string) => {
    return useMemo(() => {
        return {
            ...defaultMetaData,
            description: `Alle Informationen zur ${name} ${category} (${isin}) mit aktuellem Aktienkurs, Charts, News, Handelsplätzen und wichtigen Analysen`
        };
    }, [defaultMetaData, name, category, isin]);
};

/**
 * This hook returns a share object based on a given ISIN.
 */
const useShare = (isin: string): Share | null => {
    const store = React.useContext(DataProviderContext);

    const instrument = store.instruments[isin] as Share;

    if (!instrument) {
        return null;
    }

    return prepareShareObject(instrument);
};

export { useShare };
